import React, { useState, useRef, useCallback } from "react";
import Keyboard from "@components/KeyboardV2";
import { flowType } from "@utility/userInfo";
import { getObjectValue, urlSearchParams } from "@utility/utills";
import "react-simple-keyboard/build/css/index.css";
import style from "./simpleKeyboard.module.scss";
import cn from "classnames";
import { ReactComponent as CrossIcon } from "@assets/images/cross.svg";
import { LABEL, CUSTOM_MESSAGES } from '../../../../veriables';
import { TouchableButton, TouchableDiv } from "../../Touchable/index";

const loginKeyboard = (props) => {
  // Props Destructuring

  const {
    name,
    placeholder,
    onSubmit,
    validate,
    goToSwiper,
    containerClass,
    buttonName,
    closeBtn,
    handleClose,
    isKioskMode,
    isEmployeeCheck,
    auth,
    setLoginError,
    serverAppTheme,
    LockIconPopUp,
    isOtherPaymentOptionLogin,
    employeeCheck,
    handleLoyaltyInfo,
    isLandScape,
    orderingPortraitOrientation
  } = props;

  // State Management

  const ref = useRef(null);
  const [error, setError] = useState("");
  const [inputName, setInputName] = useState(`${name}`);
  const deviceInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem("deviceInfo"), false),
  );
  const isCounter = getObjectValue(
    () => [1].includes(deviceInfo.deviceGroup?.startMode),
    false,
  );
  const isDriveThru = getObjectValue(
    () => [3].includes(deviceInfo.deviceGroup?.startMode),
    false,
  );
  const isCallCenter = getObjectValue(
    () => [2].includes(deviceInfo?.deviceGroup?.startMode),
    false,
  );
  const isServerApp = flowType() === "serverApp";
  const [typed, setTyped] = useState("");

  // Methods

  const onChangeInput = (event) => {
    const inputVal = event.target.value;
    if (ref.current) {
      ref.current.setInput(inputVal, inputName);
    }
  };

  const handleSubmit = () => {
    const data = {
      employeeCode: typed,
      loginKeyboard: typed,
      managerCode: typed,
    };
    validate(data)
      .then(() => {
        onSubmit(data);
        setTyped("");
        if (ref.current) {
          ref.current.setInput("");
        }
      })
      .catch((err) => {
        setError(err.message);
        setLoginError && setLoginError(err.message);
      });
  };

  const handleBlur = () => {
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  const handleClear = () => {
    const element = document.querySelector(`#${name}`);
    element.value = "";
    setTyped("");
    if (ref.current) {
      ref.current.setInput("", inputName);
    }
    setError("");
    setLoginError && setLoginError("");
  };

  // Stable reference — functional update avoids closing over `typed`,
  // so KeyboardContainer (memo'd) does not re-render on every keystroke.
  const onClickBtn = useCallback((value) => {
    setError("");
    setLoginError?.("");
    setTyped(prev => value === "{bksp}" ? prev.slice(0, -1) : prev.concat(value));
  }, [setLoginError]);

  const getButton = (isOtherPaymentOption) => {
    return isOtherPaymentOption ? (
      <div className="row">
      <div className={cn(isLandScape && "pr-0 pl-4 justify-content-center align-items-center", "col-12 d-flex" )} style={{
          position: 'fixed',
          bottom: !isLandScape
            ? '17px'
            : (!isOtherPaymentOptionLogin ||
              ['12', '32', '4', '28', '16', '22'].includes(urlSearchParams('screenType')))
              ? '17px'
              : '16px',
        }}>
        <div className={cn(isLandScape ? "col-5" : "col-6", "text-center pl-0 pr-2")}>
          <TouchableButton
            className={cn(
              !isLandScape && "btnNewUI", "btn-ripple w-100 fs_28 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color",
              style.fw600
            )}
            style={{
                borderRadius: "4px",
                border: "1px solid #2541A4",
                backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                color: serverAppTheme?.primary_text,
            }}
            type="button"
            onClick={(e) => {
              handleClose();
              e.preventDefault();
            }}
            rippleEffect={true}
          >
            {LABEL().EPS_CANCEL}
          </TouchableButton>
        </div>

        <div className={cn(isLandScape ? "col-5" : "col-6", "text-center p-0")}>
          <TouchableButton
            className={cn(
              !isLandScape && "btnNewUI", "btn-ripple shadow-none border-0 w-100 fs_28 od-primary-btn-bg-color od-primary-btn-font-color",
              style.fw600
            )}
            style={{
              borderRadius: "4px",
              background: serverAppTheme?.secondaryBtn,
              color: serverAppTheme?.btn_font_color,
            }}
            type="button"
            onClick={(e) => {
              handleLoyaltyInfo({ phoneNumber: null, email: null, type: null });
              deviceInfo?.deviceGroup?.serverAppSettings?.disableLoginWithKeypad
                ? goToSwiper()
                : handleSubmit();
              e.preventDefault();
            }}
            rippleEffect={true}
          >
            {LABEL().EPS_LOGIN}
          </TouchableButton>
        </div>
        </div>
        </div>
    ) : (
        <div className={cn("col-12 d-flex px-0", orderingPortraitOrientation ? 'position-absolute' : 'position-relative')} style={{ bottom: orderingPortraitOrientation ? '22%' : ''} }>
        {closeBtn &&
      <div className="col-6 text-center pl-0 pr-2">
        <TouchableButton
          type="button"
          className={cn('px-0 mb-2 mt-3 pl-2 rounded btn-ripple fs_24 fw-600 w-100', orderingPortraitOrientation ? 'btn68' : 'btn44')}
          onClick={(e) => {
            handleClose();
            e.preventDefault();
          }}
          style={{ backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }}
          rippleEffect={true}
        >
          {LABEL().CANCEL}
        </TouchableButton>
        </div>
  }
      <div className={cn("px-0", closeBtn ? "col-6" : "col-12")}>
      {buttonName &&
        <TouchableButton
        className={cn(
          "btn-ripple w-100",
          inputName === "managerCode" ? "mt-3" : "mt-0",
          // style.loginBtn,
          ["kiosk"].includes(flowType())
            ? "fs-30 btn100"
            : buttonName === "Submit"
              ? "fs_24 border-0 rounded"
              : "fs_24 w-100",
              orderingPortraitOrientation ? 'btn68' : 'btn44'
        )}
        type="button"
        onClick={() => {
          deviceInfo?.deviceGroup?.serverAppSettings?.disableLoginWithKeypad
            ? goToSwiper()
            : handleSubmit();
        }}
        style={{
          height: buttonName === "Submit" && "",
          backgroundColor: serverAppTheme?.secondaryBtn,
          color: serverAppTheme?.btn_font_color,
        }}
        rippleEffect={true}
      >
        {buttonName}
      </TouchableButton>}
      </div>
      </div>

    );
  };
  const loginKeypad =
    deviceInfo?.deviceGroup?.serverAppSettings?.disableLoginWithKeypad ||
    (!deviceInfo?.deviceGroup?.serverAppSettings?.enableLoginWithCard &&
      deviceInfo?.deviceGroup?.serverAppSettings?.disableLoginWithKeypad);

  // HTMl CSS CODE

  return (
    <div
      className={containerClass}
      style={{
        paddingTop: auth.serverAppFeatures?.disableLoginWithKeypad && "52%",
      }}
    >
      <div className={cn(style.loginContainer, "h-100 position-relative", loginKeypad &&
        !isKioskMode && "d-flex")}>
        {/* <div className={cn(LockIconPopUp ? 'pb-0' : isOtherPaymentOptionLogin && "pb-4")}> */}
        <div className={cn(LockIconPopUp ? 'pb-0' : (isOtherPaymentOptionLogin ? "pb-4" : "", orderingPortraitOrientation ? 'pb-3' : ''))}>
          {
            isOtherPaymentOptionLogin && (
              <div className={cn(isLandScape ? "pb-12" : "pb-5 mb-5", "w-100 text-center fs-24")}>
                {CUSTOM_MESSAGES().EPS_CASH_PAYMENT_PROCESSED_BY_SERVER}
              </div>
            )
          }
          {(!isKioskMode && loginKeypad) ? '' : (
            <div
              className={cn(
                "col-12 my-0 mx-0 px-0 justify-content-center h-100"
              )}
            >
              <input
                id={name}
                type="text"
                name={name}
                className={cn(
                  isLandScape ? "col-8" : "form-control",
                  buttonName === "Submit" &&
                  isServerApp &&
                  (inputName === "managerCode" ? "fs_32 fw-400" : "fs_26"),
                  inputName === "managerCode"
                    ? style.inputFieldManager
                    : style.inputField,
                )}
                placeholder={placeholder}
                value={typed}
                onFocus={() => {
                  handleBlur();
                  setInputName(`${name}`);
                }}
                onChange={onChangeInput}
                style={{
                  height: employeeCheck ? (isLandScape ? '3rem' : '4rem') :
                    buttonName === "Submit" &&
                    (!isCounter || !isDriveThru || !isCallCenter) &&
                    !isServerApp &&
                    (inputName === "managerCode" ? "64px" : "6.4vh"),
                  border: "none",
                  background: serverAppTheme?.inputBg,
                  borderBottom: serverAppTheme?.inputBorder_Bottom,
                  color: serverAppTheme?.primary_text,
                  "--placeholder-color": serverAppTheme?.input_placeholder,
                }}
              />
              {error.length > 0 && inputName === "employeeCode" && (
  <div
    className="fs-12 text-primary text-right"
  >
    {error}
  </div>
)}
              {typed.length > 0 && (
                <TouchableDiv
                  role="presentation"
                  className={cn(
                    "position-absolute d-flex align-items-center",
                    ["kiosk"].includes(flowType()) ? "fs-30" : "fs_24",
                  )}
                  style={{
                    right: isLandScape ? "150px" : "10px",
                    top: inputName === "managerCode" ? "17%" : "16%",
                    // transform: 'translateY(-50%)',
                    height: buttonName === "Submit" ? "4.4vh" : "2.7rem",
                  }}
                  onClick={() => {
                    handleClear();
                  }}
                >
                  <CrossIcon fill={serverAppTheme?.iconcolor} alt="cross" />
                </TouchableDiv>
              )}
            </div>
          )}
          {error.length > 0 && (!isKioskMode && loginKeypad) && (
            <div
              className={cn("fs_12 text-right", (!isOtherPaymentOptionLogin && LockIconPopUp) && 'position-absolute')}
              style={{
                color: serverAppTheme?.error_text,
                top: (!isOtherPaymentOptionLogin && LockIconPopUp) && '2.8rem',
                right: (!isOtherPaymentOptionLogin && LockIconPopUp) && 0
              }}
            >
              {error}
            </div>
          )}
        </div>

        <div
          style={{ backgroundColor: serverAppTheme?.keyBoard_Bg_Color }}
          className={cn(
            "pl-2 pr-1",
            loginKeypad && !isKioskMode ? "" : "pb-2",
            error.length > 0
              ? LockIconPopUp
                ? "pt-2"
                : "pt-0"
                : loginKeypad && !isKioskMode ? "" : !error && `pt-2 ${employeeCheck && !isLandScape ? 'mt-3' : ''}`,
          )}
        >
          <div className={cn("fs-12 text-primary text-right")}>{inputName !== "employeeCode" && error.length > 0 && error}</div>
          {loginKeypad && !isKioskMode
            ? (
              ""
            ) : (
              <div className={cn("px-0")}>
                <Keyboard
                  onClickBtn={onClickBtn}
                  type={isEmployeeCheck ? "numeric" : "swipe"}
                  customClass={cn(style.keys, "h-100")}
                  btnSize="btn35 py-2"
                  goToSwipe={goToSwiper}
                  auth={auth}
                  employeeCheck={employeeCheck}
                  screenType="loginContainer"
                />
              </div>
            )}
        </div>
        <div className={cn(style.loginBtnContainer, "h-12 mt-0", loginKeypad &&
          !isKioskMode && "col-12 p-0")}>
          {isKioskMode ? (
            <div
              className={cn(
                "h-10 w-100 align-items-center justify-content-center",
              )}
            >
              <div className="col-12 d-flex my-2">
                {isEmployeeCheck && (
                  <div className="col-6 text-center">
                    <button
                      className={cn(
                        "btn btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 fs-30",
                      )}
                      type="button"
                      onClick={() => handleClose()}
                    >
                      {closeBtn}
                    </button>
                  </div>
                )}
                <div
                  className={cn(
                    "text-center",
                    isEmployeeCheck ? "col-6" : "col-12",
                  )}
                >
                  <button
                    className={cn("btn btn-ripple shadow-none border-0 fs-38")}
                    type="button"
                    onClick={() => handleSubmit()}
                  >
                    {buttonName}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            getButton(LockIconPopUp)
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(loginKeyboard);
